import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  Character,
} from "@dndModels";

import ButtonBox from "@components/input/buttons/ButtonBox";
import ModalOrDrawer from "@components/display/ModalOrDrawer";
import CharacterManageInventory from "@dndComponents/character/inventory/manage/CharacterManageInventory";
import CenteredMenu from "@components/input/menus/CenteredMenu";
// import CharacterManageRecipes from '../knowledge/CharacterManageRecipes';
import CharacterManageRecipeComponents from "@dndComponents/character/inventory/manage/CharacterManageRecipeComponents";

interface Props {
  character: Character;
  disabled: boolean;
  shared: boolean;
}

export default function CharacterManageInventoryButton({
  character,
  disabled,
  shared,
}: Props) {
  const [open, setOpen] = useState(false);
  const [view, setView] = useState<"Manage Inventory" | "Recipes" | "Components">("Manage Inventory");

  const renderExtras = () => {
    return (
      <ModalOrDrawer
        open={ open } 
        onClose={() => {
          setOpen(false);
          character.subscription_holder.modalClosed();
        }}>
        { open &&
          <Grid container spacing={0} direction="row">
            { character.character_options.use_item_crafting &&
              <Grid size={12}>
                <CenteredMenu
                  selected={view}
                  // options={["Manage Inventory","Recipes","Components"]}
                  options={["Manage Inventory","Components"]}
                  onSelect={(changed: string) => {
                    setView(changed as "Manage Inventory" | "Recipes" | "Components");
                  }}
                />
              </Grid>
            }
            <Grid
              size={{
                xs: 12
              }}>
              { view === "Manage Inventory" ?
                <CharacterManageInventory
                  char={character}
                  shared={shared}
                />
              // : view === "Recipes" ?
              //   <CharacterManageRecipes
              //     char={character}
              //     onChange={onChange}
              //   />
              : 
                <CharacterManageRecipeComponents
                  character={character}
                />
              }
            </Grid>
          </Grid>
        }
      </ModalOrDrawer>
    );
  }

  return (
    <>
      <ButtonBox
        name={ character.character_options.use_item_crafting ? "Manage Inventory/Recipes/Components" : "Manage Inventory" }
        disabled={disabled}
        onClick={() => {
          setOpen(true);
        }}
      />
      { renderExtras() }
    </>
  )
}
